import getUaParam from '@/utils/getUaParam'
import request from '.'
import {getApiUrl} from '@/utils'

export interface TenReportRes{
  userId: number
  registerYear: number
  registerSequence: number
  firstCourseYear: number
  firstCoursePlaybackUrl: string
  studyMinutes2020: number | string
  studyMinutes2023: number | string
  latestStudyTime2020: number
  longestClassTeacher2020: string
  longestClassStudyCount2020: number
  activeDevices2020: number
  activeDevices2021To2022: number
  activeDevices2023: number
  activeDevices2017: number
  personalDataConsentFormUrl: string
  registerDays: number
  userIconUrl:string
}

const uploadURL = process.env.NEXT_PUBLIC_API_BASE_URL_PRE
const tjUrl = process.env.NEXT_PUBLIC_ACTIVITY_API_BASE_URL
const base = process.env.NEXT_PUBLIC_API_BASE_URL_PRE
/**
 * @description: 获取十周年报告数据
 */
export const getTenReport = (ctx?: CTX) =>
    request<TenReportRes>({
        url: '/tj-yingxiao/tj-fission/tenAnniversary/getTenYearAnniversaryReport',
        method: 'post',
        ctx,
        baseURL: tjUrl,
    }).then((res) => {
        const {success, data} = res
        if (!success || !data) {
            return res
        }
        if (success) {
            return {
                ...res,
                data: {
                    userId: data.userId || 0,
                    registerYear: data.registerYear || 0,
                    registerDays: data.registerDays || 0,
                    registerSequence: data.registerSequence || 0,
                    firstCourseYear: data.firstCourseYear || 0,
                    firstCoursePlaybackUrl: data.firstCoursePlaybackUrl || '',
                    studyMinutes2020: data.studyMinutes2020 || 0,
                    studyMinutes2023: data.studyMinutes2023 || 0,
                    latestStudyTime2020: data.latestStudyTime2020 || 0,
                    longestClassTeacher2020: data.longestClassTeacher2020 || '',
                    longestClassStudyCount2020: data.longestClassStudyCount2020 || 0,
                    activeDevices2020: data.activeDevices2020 || 0,
                    activeDevices2021To2022: data.activeDevices2021To2022 || 0,
                    activeDevices2023: data.activeDevices2023 || 0,
                    activeDevices2017: data.activeDevices2017 || 0,
                    personalDataConsentFormUrl: data.personalDataConsentFormUrl || '',
                    userIconUrl: data.userIconUrl || 'https://p.gsxcdn.com/2421605306_1btkkzub.png',
                } as TenReportRes,
            }
        }
        return res
    })

export interface UploadImageRes{
  url: string
}
// 图片上传到cdn
export const uploadImageToCdn = (data: FormData, ctx?: CTX) =>
    request<UploadImageRes>({
        url: '/v1/storage/upload',
        method: 'post',
        data,
        ctx,
        baseURL: uploadURL,
        headers: {'Content-Type': 'multipart/form-data'},
    })

type WxConfigReq = {
  url: string
}
// 获取微信配置
export const getWxCofig = (data: WxConfigReq, ctx?: CTX) => {
    const url = getApiUrl()
    return request<any>({
        url: '/v1/h5/weixinJsConfig',
        method: 'post',
        data,
        ctx,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        baseURL: url,
    })
}

export interface ImageAuthReq {
  url: string,
  width: number,
  height: number,
}

export interface ImageAuthRes{
  result: boolean
  desc:string
}
// 图片审核
export const imageIsAuth = (data:ImageAuthReq, ctx?: CTX) =>
    request<ImageAuthRes>({
        url: '/tj-yingxiao/tj-fission/tenAnniversary/picture/audit',
        method: 'post',
        data,
        ctx,
        baseURL: tjUrl,
    })

export interface DiscoverCacheReq{
      data:string
    }
// 发现页缓存
export const discoverCache = (data:DiscoverCacheReq, ctx?: CTX) =>
    request({
        url: '/linglong-api/common/cache',
        method: 'post',
        data,
        ctx,
        baseURL: base,
    })

export interface RewardInfo {
      rewardId: number;
      rewardType: number;
      rewardName: string;
      rewardImgUrl: string;
      count: number;
      stock?: number;
      isLuckyFish?: boolean;
    }

export interface FragmentModule {
      isShow: boolean;
      fragmentList: RewardInfo[];
      rewardInfo?: {
        rewardInfo: RewardInfo;
        congratulationText: string;
        description: string;
        isNew: boolean;
      };
    }

export interface MainButton {
      text: string;
      status: number; // 1：未登录，2：碎片未集齐，3：已集齐，但未合成，4：已集齐，且已合成，5：已开奖
    }

export interface SubActivityModule {
      name: string;
      coverUrl: string;
      videoUrl?: string;
      jumpUrl: string;
      isLock: boolean;
      lockToast?: string;
      fragmentStatus: number;
      missionType: number;
      description?: string;
    }

export interface Mission {
      iconUrl: string;
      title: string;
      subTitle: string;
      rewardId: string;
      rewardName?: string;
      signDays?: number;
      buttonName?: string;
      jumpUrl?: string;
      missionStatus: number; // 0-未完成，3-待领取奖励，1-已完成且领取奖励
      missionType: number;
    }
export interface MissionModule {
      isExpired: boolean;
      signMission: {
        userSignDays: number;
        maxSignDays: number;
        missionList: Mission[];
        missionType: number;
        signButtonStatus: number; // 0-未签到，1-已签到，2-已完成
        buttonName: string;
      };
      missionList: Mission[];
}

export interface winnerItem {
  userId: string,
  name: string,
  userIcon: string,
  rewardName: string,
}

export interface CombineIndexReq {
      fragmentModule: FragmentModule;
      winnerList: winnerItem[];
      mainButton: MainButton;
      subActivityModuleList: SubActivityModule[];
      missionModule: MissionModule;
      activityPhase: 0 | 1 | 2 | 3; //0-活动未开始，1-集碎片阶段，2-开奖阶段，3-活动已结束
      isLogin: boolean;
    }

// 聚合页首页
export const combineIndex = (fromId?: number, isApp?:boolean, ctx?: CTX) =>
    request<CombineIndexReq>({
        url: '/tj-yingxiao/tj-fission/tenAnniversary/indexPage',
        params: {fromId, isApp},
        method: 'get',
        ctx,
        baseURL: tjUrl,
    })
export interface Prize {
      rewardId: number;
      rewardType: number;
      rewardName: string;
      rewardImgUrl: string;
      count: number;
      stock: number;
      isLuckyFish: boolean;
    }

export interface GiftPoolRes {
      firstPrizeList: Prize[];
      secondPrizeList: Prize[];
      thirdPrizeList: Prize[];
      fourthPrizeList: Prize[];
      participationPrizeList: Prize[];
    }
// 奖池信息
export const giftPool = (fromId?:number, ctx?: CTX) =>
    request<GiftPoolRes>({
        url: '/tj-yingxiao/tj-fission/tenAnniversary/prizePoolInfo',
        method: 'get',
        params: {fromId},
        ctx,
        baseURL: tjUrl,
    })
// 做任务
export interface DoMissionRes {
  rewardInfo: RewardInfo;
  congratulationText: string;
  description: string;
  isNew: boolean;
}

export interface DoMissionReq {
  fromId: number;
  missionType: number;
  operationType: number; // 1：完成任务，2：领取奖励
}
// 做任务
export const doMission = (data:DoMissionReq, ctx?: CTX) =>
    request<DoMissionRes>({
        url: '/tj-yingxiao/tj-fission/tenAnniversary/doMission',
        method: 'post',
        data,
        ctx,
        baseURL: tjUrl,
    })
// 开奖
export const openReward = (fromId:string, ctx?: CTX) =>
    request<DoMissionRes>({
        url: '/tj-yingxiao/tj-fission/tenAnniversary/draw',
        method: 'post',
        data: {fromId},
        ctx,
        baseURL: tjUrl,
    })
// 合成蛋糕
export const combineCake = (fromId:string, ctx?: CTX) =>
    request({
        url: '/tj-yingxiao/tj-fission/tenAnniversary/synthesizeCake',
        method: 'post',
        data: {fromId},
        ctx,
        baseURL: tjUrl,
    })

export interface GoodDataRes {
  imgUrlList: string[];
  synthesizeCakeTotal: number;
  synthesizeCakeTargetList: number[];
  userFragmentTypeNum: number;
  synthesizeCakeFragmentTypeNum: number;
  blessTopicUrl: string;
}
// 公益页面
export const getGoodPageData = (fromId?:number, ctx?: CTX) =>
    request<GoodDataRes>({
        url: '/tj-yingxiao/tj-fission/tenAnniversary/publicWelfarePage',
        method: 'get',
        params: {fromId},
        ctx,
        baseURL: tjUrl,
    })

